import React from 'react';
import PropTypes from 'prop-types';
import style from './user-avatar.module.less';

const getInitials = (name = '') => {
  return name
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter((word, index) => index < 2)
    .map((word) => word[0])
    .join('');
};

const LetterAvatar = ({ letters = '' }) => <div className={style['text-avatar']}>{letters}</div>;

LetterAvatar.propTypes = { letters: PropTypes.string };

const PictureAvatar = ({ imgUrl, alt = 'User Avatar' }) => <img alt={alt} src={imgUrl} />;

PictureAvatar.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

const UserAvatar = ({ name, userName, imgUrl }) => {
  let avatar;

  if (imgUrl) {
    avatar = <PictureAvatar alt={name || userName} imgUrl={imgUrl} />;
  } else {
    avatar = <LetterAvatar letters={getInitials(name || userName)} />;
  }

  return <div className={style['avatar-container']}>{avatar}</div>;
};

UserAvatar.propTypes = {
  name: PropTypes.string,
  userName: PropTypes.string,
  imgUrl: PropTypes.string,
};

export default UserAvatar;
